module.exports = {
  ReadonlyDate: Date,
}
